import PrivacyPolicyAgreementModal from '../../components/molecules/modals/agreement/PrivacyPolicyAgreementModal'

export default {
  components: {
    PrivacyPolicyAgreementModal
  }
}
